import { FC } from 'react';
import { Image } from 'components/Image';
import { ENV_CONFIG } from 'config/environment';
import { IRecipients } from 'store/recipients/types';

interface Props {
  candidates: IRecipients[];
}

export const CompactRecipients: FC<Props> = ({ candidates }) => {
  return (
    <div className="recipient-grid">
      {candidates.map((rec, index) => (
        <div key={index} className="recipient-container">
          <Image
            alt={`Recipient ${rec.recipient_name}`}
            src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/recipients/rec_${rec.misc_ids?.photo_id}.jpg`}
            fallbackImgType="candidate_square"
          />
          <div className="candidate-name">
            <div>{rec.recipient_name}</div>
            <div>{rec.race?.election.display_info}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
